// extracted by mini-css-extract-plugin
export default {"Header":"People_Header__ncp7X","Content":"People_Content__IvY9q","PeopleContainer":"People_PeopleContainer__rqXET"};